<script>
    import Vue from 'vue';
    export default {
        data() {
            return {
                open: false,
                current: 0,
                selection: ''
            }
        },
        props: {
            suggestions: Array,
            selectedModel: Object,
            placeholder: String
            // selection: String
            // suggestions: {
            //     type: Array,
            //     required: true
            // },
            // selection: {
            //     type: String,
            //     required: true,
            //     twoWay: true
            // }
        },
        created(){
            let _self = this;
            this.$topnavbar.$on('clearACObject', () => {
                _self.selection = '';
                this.$emit('update:selectedModel',  '')
            });
        },
        computed: {
            matches() {
                return this.suggestions.filter((str) => {
                    return str.name.toLowerCase().indexOf(this.selection.toLowerCase()) >= 0;
                });
            },
            openSuggestion() {
                return this.selection !== "" &&
                    this.matches.length !== 0 &&
                    this.open === true;
            }
        },
        methods: {
            enter() {
                this.$emit('update:selectedModel',  this.matches[this.current])
                // this.$emit('selected-model', this.matches[this.current])
                this.selection = this.matches[this.current].name;
                this.open = false;
            },
            up() {
                if(this.current > 0)
                    this.current--;
            },
            down() {
                if(this.current < this.matches.length - 1)
                    this.current++;
            },
            isActive(index) {
                return index === this.current;
            },
            change() {
                if (this.open === false) {
                    this.open = true;
                    this.current = 0;
                }
            },
            suggestionClick(index) {
                this.$emit('update:selectedModel',  this.matches[index])
                this.selection = this.matches[index].name;
                this.open = false;
            },
        }
    }
</script>
<template>
  <div style="position:relative" v-bind:class="{'open':openSuggestion}">
    <input class="form-control" type="text" v-model="selection"
           v-bind:placeholder="placeholder"
           @keydown.enter = 'enter'
           @keydown.down = 'down'
           @keydown.up = 'up'
           @input = 'change'
    />
    <ul class="dropdown-menu" style="width:100%">
      <li v-for="(suggestion,index) in matches"
          v-bind:class="{'active': isActive(index)}"
          @click="suggestionClick(index)"
      >
        <a style="cursor: pointer;">{{ suggestion.name }}</a>
      </li>
    </ul>
  </div>
</template>


// WEBPACK FOOTER //
// AutocompleteObject.vue?6e513162